import { MdKeyboardArrowDown, MdKeyboardArrowRight,MdOutlineKeyboardArrowRight,MdOutlineRemoveRedEye,MdOutlineDelete,MdOutlineFileUpload,MdDeleteOutline,MdOutlineFileDownload,MdArrowDropDown,MdKeyboardArrowUp, MdOutlineBreakfastDining  } from "react-icons/md";
import { IoSettingsOutline,IoCloseSharp, IoClose } from "react-icons/io5";
import { FaAnglesRight, FaAnglesLeft,FaListUl, FaBoxOpen } from "react-icons/fa6";
import { HiOutlineDocumentDuplicate } from "react-icons/hi2";
import { RiFileExcel2Fill,RiArrowLeftSFill } from "react-icons/ri";
import { BiEditAlt,BiCloudUpload } from "react-icons/bi";
import { AiOutlinePrinter } from "react-icons/ai";
import { FaRegEdit,FaSave,FaSortUp,FaSortDown} from 'react-icons/fa';
import { LuFilePlus2} from "react-icons/lu";
import { MdFilterAlt, MdAdd, MdOutlineImportExport, MdOutlineClose, MdOutlineEdit } from "react-icons/md";
import { IoIosAddCircle, IoIosCheckmarkCircle } from "react-icons/io";
import { IoMdArrowDropdown } from "react-icons/io";
import { BsUpcScan, BsThreeDotsVertical } from "react-icons/bs";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { PiSlidersHorizontalBold } from "react-icons/pi";
import { FaPlus } from "react-icons/fa6";
import { CgAttachment } from "react-icons/cg";
import { GrCopy } from "react-icons/gr";
import { IoMdBarcode } from "react-icons/io";
import { FaSitemap } from "react-icons/fa";
import { GoClock } from "react-icons/go";
import { GrFormPrevious } from "react-icons/gr";
import { IoCloudDownload } from "react-icons/io5";
import { IoFilterSharp } from "react-icons/io5";

  
export const iconMap = {
  GrFormPrevious,
  FaSitemap,
  MdArrowDropDown ,
  IoMdBarcode,
  PiSlidersHorizontalBold,
  MdOutlineFileDownload,
  CgAttachment,
  GrCopy,
  IoClose,
  FaPlus ,
  FiPlus,
  MdDeleteOutline,
  FaSortUp,
  FaSortDown,
  MdAdd,
  FaSave,
  FiTrash2,
  FaListUl ,
  BiEditAlt,
  BsUpcScan,
  FaRegEdit,
  LuFilePlus2,
  MdFilterAlt,
  IoCloseSharp,
  FaAnglesLeft,
  MdOutlineEdit,
  BiCloudUpload,
  FaAnglesRight,
  MdOutlineClose,
  IoIosAddCircle,
  MdOutlineDelete,
  AiOutlinePrinter,
  RiFileExcel2Fill,
  RiArrowLeftSFill,
  IoSettingsOutline,
  IoMdArrowDropdown,
  MdOutlineFileUpload,
  BsThreeDotsVertical,
  MdKeyboardArrowDown, 
  MdKeyboardArrowRight, 
  IoIosCheckmarkCircle,
  MdOutlineImportExport, 
  MdOutlineRemoveRedEye,
  MdOutlineBreakfastDining,
  HiOutlineDocumentDuplicate,
  MdOutlineKeyboardArrowRight,
  MdKeyboardArrowUp,
  GoClock,
  IoCloudDownload,
  IoFilterSharp,
  FaBoxOpen
  
}

const GetIcon = ({ iconName, size = 23, color = "",design='',child='',action=()=>{},style = {}  }) => {
  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent size={size} color={color} children={child} onClick={action}  className={design}   style={style} /> : null
};

export default GetIcon;
